var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pad20 flex flex-item1 mar20-b border" }, [
    _c("div", { staticClass: "item flex-shrink" }, [
      _c("div", { staticClass: "fb f16 mar15-b" }, [_vm._v("付款信息")]),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "w80 mar10-b gray6" }, [_vm._v("支付类型")]),
        _c("div", { staticClass: "flex-auto mar10-b" }, [
          _vm._v(_vm._s(_vm.detail.paymentTypeCn))
        ])
      ]),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "w80 mar10-b gray6" }, [_vm._v("支付状态")]),
        _c("div", { staticClass: "flex-auto mar10-b" }, [
          _vm._v(_vm._s(_vm.detail.paymentStCn))
        ])
      ]),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "w80 mar10-b gray6" }, [_vm._v("结算状态")]),
        _c("div", { staticClass: "flex-auto mar10-b" }, [
          _vm._v(_vm._s(_vm.detail.balanceStCn))
        ])
      ]),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "w80 mar10-b gray6" }, [_vm._v("下单时间")]),
        _c("div", { staticClass: "flex-auto mar10-b" }, [
          _vm._v(_vm._s(_vm.detail.orderTime))
        ])
      ]),
      _vm.detail.paymentTime
        ? _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "w80 mar10-b gray6" }, [
              _vm._v("支付时间")
            ]),
            _c("div", { staticClass: "flex-auto mar10-b" }, [
              _vm._v(_vm._s(_vm.detail.paymentTime))
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "w80 mar10-b gray6" }, [_vm._v("订单金额")]),
        _vm.dataMasking
          ? _c("div", { staticClass: "flex-auto mar10-b" }, [_vm._v("****")])
          : _c("div", { staticClass: "flex-auto mar10-b" }, [
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.detail.fmoney
                      ? parseFloat(_vm.detail.fmoney.toString()).toFixed(2)
                      : "0.00"
                  )
                )
              ]),
              _c("div", [
                _vm._v(
                  "\n          （含运费\n          " +
                    _vm._s(
                      _vm.detail.freightMoney
                        ? parseFloat(
                            _vm.detail.freightMoney.toString()
                          ).toFixed(2)
                        : "0.00"
                    ) +
                    "\n          ）\n        "
                )
              ])
            ])
      ])
    ]),
    _c("div", { staticClass: "item flex-shrink border-l pad20-l" }, [
      _c("div", { staticClass: "fb f16 mar15-b" }, [_vm._v("收货人信息")]),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "w80 mar10-b gray6" }, [
          _vm._v(_vm._s(_vm.detail.delivery == "2" ? "自提人" : "收货人"))
        ]),
        _vm.dataMasking
          ? _c("div", { staticClass: "flex-auto mar10-b" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.detail.orderTransportDtlBo.linkman.substring(0, 1) +
                      new Array(
                        _vm.detail.orderTransportDtlBo.linkman.length
                      ).join("*")
                  ) +
                  "\n      "
              )
            ])
          : _c("div", { staticClass: "flex-auto mar10-b" }, [
              _vm._v(_vm._s(_vm.detail.orderTransportDtlBo.linkman))
            ])
      ]),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "w80 mar10-b gray6" }, [_vm._v("电话")]),
        _c("div", { staticClass: "flex-auto mar10-b" }, [
          _vm._v(_vm._s(_vm.detail.orderTransportDtlBo.tel))
        ])
      ]),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "w80 mar10-b no-warp gray6" }, [
          _vm._v(_vm._s(_vm.detail.delivery == "2" ? "自提地址" : "收货地址"))
        ]),
        _vm.dataMasking
          ? _c("div", { staticClass: "flex-auto pad10-r mar10-b" }, [
              _vm._v(
                _vm._s(
                  _vm.detail.orderTransportDtlBo.addr.replace(
                    /^(.{1}).+(.)/,
                    "$1**$2"
                  )
                )
              )
            ])
          : _c("div", { staticClass: "flex-auto pad10-r mar10-b" }, [
              _vm._v(_vm._s(_vm.detail.orderTransportDtlBo.addr))
            ])
      ])
    ]),
    _c("div", { staticClass: "item flex-auto border-l pad20-l" }, [
      _c("div", { staticClass: "fb f16 mar15-b" }, [_vm._v("配送信息")]),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "w102 mar10-b gray6" }, [_vm._v("配送方式")]),
        _c("div", { staticClass: "flex-auto mar10-b" }, [
          _vm._v(_vm._s(_vm.detail.delivery == "2" ? "买家自提" : "卖家配送"))
        ])
      ]),
      _vm.detail.delivery == "1" &&
      _vm.detail.orderTransportDtlBo.sellerConfirmPickupTimeStr
        ? _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "w102 mar10-b gray6" }, [
              _vm._v("预计发货时间")
            ]),
            _c("div", { staticClass: "flex-auto mar10-b" }, [
              _vm._v(
                _vm._s(
                  _vm.detail.orderTransportDtlBo.sellerConfirmPickupTimeStr
                )
              )
            ])
          ])
        : _vm._e(),
      _vm.detail.delivery == "1" && _vm.detail.sendTime
        ? _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "w102 mar10-b gray6" }, [
              _vm._v("发货时间")
            ]),
            _c("div", { staticClass: "flex-auto mar10-b" }, [
              _vm._v(_vm._s(_vm.detail.sendTime))
            ])
          ])
        : _vm._e(),
      _vm.detail.delivery == "2"
        ? _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "w102 mar10-b gray6" }, [
              _vm._v("自提时间")
            ]),
            !_vm.detail.orderTransportDtlBo.selfPickupTimeType
              ? _c("div", { staticClass: "flex-auto mar10-b" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.detail.orderTransportDtlBo.pickupTime) +
                      "\n      "
                  )
                ])
              : _vm.detail.orderTransportDtlBo.sellerConfirmPickupTimeStr
              ? _c("div", { staticClass: "flex-auto mar10-b" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.detail.orderTransportDtlBo
                          .sellerConfirmPickupTimeStr
                      ) +
                      "\n        " +
                      _vm._s(
                        _vm.detail.orderTransportDtlBo.sellerConfirmPickupPeriod
                      ) +
                      "\n      "
                  )
                ])
              : _c(
                  "div",
                  {
                    staticClass: "flex-auto mar10-b",
                    staticStyle: { color: "#e4ab66" }
                  },
                  [_vm._v("\n        " + _vm._s("待卖家确认") + "\n      ")]
                )
          ])
        : _vm._e(),
      _vm.detail.orderDtlBo.orderVehicleStatus == 1 && _vm.detail.sendTime
        ? _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "w102 mar10-b gray6" }, [
              _vm._v("确认自提时间")
            ]),
            _c("div", { staticClass: "flex-auto mar10-b" }, [
              _vm._v(_vm._s(_vm.detail.sendTime))
            ])
          ])
        : _vm._e(),
      _vm.detail.receiveTime
        ? _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "w102 mar10-b gray6" }, [
              _vm._v("确认收货时间")
            ]),
            _c("div", { staticClass: "flex-auto mar10-b" }, [
              _vm._v(_vm._s(_vm.detail.receiveTime))
            ])
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("div", { staticClass: "w102 mar10-b gray6" }, [
            _vm._v("买家留言")
          ]),
          _c(
            "el-tooltip",
            {
              attrs: {
                content: _vm.detail.memo ? _vm.detail.memo : "无",
                placement: "bottom",
                effect: "light"
              }
            },
            [
              _c(
                "div",
                { staticClass: "flex-auto mar10-b pad10-r ellipsis_two" },
                [_vm._v(_vm._s(_vm.detail.memo == "" ? "无" : _vm.detail.memo))]
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("div", { staticClass: "w102 mar10-b gray6" }, [
            _vm._v("卖家留言")
          ]),
          _c(
            "el-tooltip",
            {
              attrs: {
                content: _vm.detail.memoSeller ? _vm.detail.memoSeller : "无",
                placement: "bottom",
                effect: "light"
              }
            },
            [
              _c(
                "div",
                { staticClass: "flex-auto mar10-b pad10-r ellipsis_two" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.detail.memoSeller == "" ? "无" : _vm.detail.memoSeller
                    )
                  )
                ]
              )
            ]
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "item flex-shrink border-l pad20-l" }, [
      _c("div", { staticClass: "fb f16 mar15-b" }, [_vm._v("发票信息")]),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "w102 mar10-b gray6" }, [_vm._v("发票种类")]),
        _c("div", { staticClass: "flex-auto mar10-b" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.detail.orderDtlBo.orderInvoice &&
                  _vm.detail.orderDtlBo.orderInvoice.issueTypeCn != ""
                  ? _vm.detail.orderDtlBo.orderInvoice.issueTypeCn
                  : "无"
              ) +
              "\n      "
          )
        ])
      ]),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "w102 mar10-b gray6" }, [_vm._v("发票类型")]),
        _c("div", { staticClass: "flex-auto mar10-b" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.detail.orderDtlBo.orderInvoice &&
                  _vm.detail.orderDtlBo.orderInvoice.invoicetitleTypeCn != ""
                  ? _vm.detail.orderDtlBo.orderInvoice.invoicetitleTypeCn
                  : "无"
              ) +
              "\n      "
          )
        ])
      ]),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "w102 mar10-b gray6" }, [_vm._v("发票抬头")]),
        _c("div", { staticClass: "flex-auto mar10-b" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.detail.orderDtlBo.orderInvoice &&
                  _vm.detail.orderDtlBo.orderInvoice.receipt != ""
                  ? _vm.detail.orderDtlBo.orderInvoice.receipt
                  : "无"
              ) +
              "\n      "
          )
        ])
      ]),
      _vm.detail.isReceipt === 1
        ? _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "w102 mar10-b gray6" }, [
              _vm._v("开票状态")
            ]),
            _c("div", { staticClass: "flex-auto mar10-b" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.detail.invoicePicList &&
                      _vm.detail.invoicePicList.length > 0
                      ? "已开票"
                      : "未开票"
                  ) +
                  "\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm.detail.orderDtlBo.orderInvoice &&
      _vm.detail.orderDtlBo.orderInvoice.contractUrl
        ? _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "w102 mar10-b gray6" }, [_vm._v("协议")]),
            _c("div", { staticClass: "flex-auto mar10-b" }, [
              _vm.detail.orderDtlBo.orderInvoice.invoiceContractType ===
              "invoiceSl"
                ? _c(
                    "a",
                    {
                      staticClass: "red",
                      attrs: {
                        target: "_blank",
                        href: _vm.detail.orderDtlBo.orderInvoice.contractUrl
                      }
                    },
                    [_vm._v("权利义务转让协议")]
                  )
                : _c(
                    "a",
                    {
                      staticClass: "red",
                      attrs: {
                        target: "_blank",
                        href: _vm.detail.orderDtlBo.orderInvoice.contractUrl
                      }
                    },
                    [_vm._v("代付协议")]
                  )
            ])
          ])
        : _vm._e(),
      _vm.detail.invoicePicList && _vm.detail.invoicePicList.length > 0
        ? _c(
            "div",
            { staticClass: "flex flex-wrap" },
            _vm._l(_vm.detail.invoicePicList, function(invoicePic, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "wh64 radius4 mar15-r mar15-b relative overflow"
                },
                [
                  invoicePic.suffix !== "pdf"
                    ? _c("el-image", {
                        attrs: {
                          src: invoicePic.url + "?imageView2/1/w/64/h/64",
                          "preview-src-list": _vm.detail.invoicePicList
                            .filter(function(item) {
                              return item.suffix !== "pdf"
                            })
                            .map(function(item) {
                              return item.url
                            }),
                          "initial-index": index
                        }
                      })
                    : _vm._e(),
                  invoicePic.suffix === "pdf"
                    ? _c(
                        "a",
                        { attrs: { href: invoicePic.url, target: "_blank" } },
                        [
                          _c("img", {
                            attrs: {
                              src:
                                "https://filesouthcdn.nxin.com/nxsc_1691545813992021546671317164323.png?imageView2/1/w/64/h/64"
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }